module.exports = __webpack_public_path__ + "img/pp_23.a025f248.png";